import { gql } from '@provision/graphql-client';

export const RECORD_FOLDER_ASSIGNMENT_FRAGMENT = gql`
  fragment RecordFolderAssignmentFields on RecordFolderAssignment {
    id
    recordFolderAssignmentId
    recordFolderId
    entity
    entityId
    partnerId
    title
    sortOrder
    createdAt
  }
`;
